// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"504":"d764ec93","563":"ed79e8fe","790":"9af938ba","844":"4556af02"}[chunkId] + ".chunk.js";
};